// @mui
import Stack from '@mui/material/Stack'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import OutlinedInput from '@mui/material/OutlinedInput'
// auth
import { useAuthContext } from 'src/auth/hooks'
// utils
import { firstLetterToUpperCase } from 'src/utils/change-case'
// locales
import { useLocales } from 'src/locales'
// types
import { IConfigItem } from 'src/types/user'

// ----------------------------------------------------------------------

const ConfigSelect = () => {
  const { t } = useLocales()

  const { user, onSelectConfig } = useAuthContext()
  const configs = user?.configs
  const configSelected = user?.configSelected

  const erpAccountLabel = firstLetterToUpperCase(t('config'))

  // Vérifier si la valeur sélectionnée existe dans les configs
  const selectedValue = configSelected?.id && configs?.length > 0 && configs?.some((config: IConfigItem) => config.id === configSelected.id)
    ? configSelected.id
    : ''

  return user?.role?.toLowerCase() === "admin" && configs?.length > 0 && (
    <Stack direction="row" alignItems="center" sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}>
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="configs">{erpAccountLabel}</InputLabel>
          <Select
            labelId="configs"
            value={selectedValue}
            label={erpAccountLabel}
            input={<OutlinedInput label={erpAccountLabel} />}
            onChange={(e) => onSelectConfig(e.target.value)}
          >
            {configs?.map((config: IConfigItem) => (
              <MenuItem key={config.id} value={config.id} >
                {config.locationName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
  );
}

export default ConfigSelect
